import { render, staticRenderFns } from "./Ausschreibungen.vue?vue&type=template&id=22d4570c&"
import script from "./Ausschreibungen.vue?vue&type=script&lang=js&"
export * from "./Ausschreibungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports